'use strict';

var React              = require('react'),
    classnames         = require('classnames');

var ApplicationButton = React.createClass({

  propTypes: {
    handler: React.PropTypes.func.isRequired,
    text: React.PropTypes.string,
    modifier: React.PropTypes.string
  },

  render: function() {
    var body = this.props.children || this.props.text;

    var modified = this.props.modifier ?
      'QuestionButton--' + this.props.modifier :
      null;

    var classes = classnames([
      'QuestionButton', 'htn-button', 'htn-button--secondary', modified
    ]);

    return (
      <button
        className={classes}
        onTouchEnd={this.props.handler}
        onClick={this.props.handler}>
        {body}
      </button>
    );
  }
});

module.exports = ApplicationButton;



/** WEBPACK FOOTER **
 ** ./js/screens/form/application-button.jsx
 **/